/**
 * Draws a message body or a photo caption: mentions in the brand color, and
 * every http(s) address as a real link that opens in a new tab (ISSUE-1359).
 *
 * The link carries `rel="noopener noreferrer"` so the opened page can neither
 * reach back into this tab nor learn which chat the fan came from. A long
 * address wraps anywhere instead of pushing the bubble wider than the screen.
 */
import { FOCUS_RING } from "@sportsmet/ui";
import type { ReactNode } from "react";

import { parseLinkRuns, type typeMentionRun } from "./messageText";

export const MessageRunsText = ({
  runs,
}: {
  runs: readonly typeMentionRun[];
}): ReactNode => (
  <>
    {runs.map((run, index) =>
      run.kind === "mention" ? (
        <span key={index} className="font-semibold text-primary">
          @{run.displayName}
        </span>
      ) : (
        <span key={index}>
          {parseLinkRuns(run.value).map((part, partIndex) =>
            part.kind === "link" ? (
              <a
                key={partIndex}
                href={part.href}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="message-link"
                className={`text-primary underline break-all ${FOCUS_RING}`}
              >
                {part.value}
              </a>
            ) : (
              <span key={partIndex}>{part.value}</span>
            ),
          )}
        </span>
      ),
    )}
  </>
);
